'use client'

import type { ThemeHeight } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { useSizing } from '../../hooks/use-sizing.ts'
import { useDataListContext } from './use-data-list.ts'

type DataListDescriptionProps = PropsWithChildren<ThemeHeight> & {
  className?: string
  singleLine?: boolean
}

const DataListDescription = ({
  children,
  className,
  singleLine,
  ...heightProps
}: DataListDescriptionProps) => {
  const { descriptionColorClassName, fontSizeClassName } = useDataListContext()
  const { heightClassName } = useSizing(heightProps)

  return (
    <dd
      className={cn(
        'text-ellipsis overflow-hidden',
        fontSizeClassName,
        descriptionColorClassName,
        heightClassName,
        {
          'whitespace-nowrap': singleLine,
        },
        className
      )}
    >
      {children}
    </dd>
  )
}

export { DataListDescription }
